import { useGetUnitiesQuery } from '@apis/middlewareTokkoApi/developments'
import { useGetNewUnitiesQuery as useGetUnitiesQueryMiddleware } from '@apis/mediacore/owner'
import { useGetDevelopmentQuery as useGetDevelopmentsMediacoreQuery } from '@apis/mediacore/emprendimientos'

function useQueryUnities(id: string, tokkoKey?: string) {
  const middlewarev2: boolean = process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() === 'true'

  let {
    data: allUnitiesData,
    isLoading,
    isError,
    isFetching,
  } = tokkoKey
    ? middlewarev2
      ? useGetUnitiesQueryMiddleware({ DEVELOPMENT_ID: id })
      : useGetUnitiesQuery({ API_KEY: tokkoKey, DEVELOPMENT_ID: id })
    : useGetDevelopmentsMediacoreQuery({
        CLIENT_ID: process.env.GATSBY_CLIENTID,
        DEVELOPMENT_ID: id,
      })

  if (!tokkoKey) {
    allUnitiesData = allUnitiesData?.properties
  }

  console.log(allUnitiesData)

  return {
    allUnitiesData,
    isLoading,
    isError,
    isFetching,
    isMediacore: !tokkoKey ? true : false,
  } //EDIT
}

export default useQueryUnities
